import { useQuery } from '@tanstack/react-query';
import { auditService, AuditFilters } from '@/services/audit';

export function useAuditLogs(filters: AuditFilters) {
  return useQuery({
    queryKey: ['audit', filters],
    queryFn: () => auditService.getLogs(filters),
  });
}
